import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { Slider } from "@mui/material";

export const CustomSlider = styled(Slider)({
  width: "100%",
  color: "red",
  "& .MuiSlider-thumb": {
    [`&:hover, &.Mui-focusVisible`]: {
      boxShadow: "0px 0px 0px 8px rgba(65, 95, 245, 0.4)",
    },
    [`&.Mui-active`]: {
      boxShadow: "0px 0px 0px 14pxrgba(65, 95, 245, 0.4)",
    },
  },
  "& .MuiSlider-rail ": {
    background: "white",
    height: "20px",
    opacity: 1,
  },
  "& .MuiSlider-track ": {
    background: "rgba(150, 191, 255, 1)",
    height: "20px",
    border: "none",
  },
  "& .MuiSlider-thumb ": {
    background: "rgba(65, 95, 245, 1)",
    height: "35px",
    width: "35px",
  },
});

const CalculateCost = () => {
  const [sliderValue, setSliderValue] = useState(5);
  const [maus, setMaus] = useState(0);
  const [price, setPrice] = useState(0);

  const setSlidersValues = (value) => {
    setSliderValue(value);

    const calculatedMaus = Math.round((value / 100) * 1000000);
    setMaus(calculatedMaus);

    if (calculatedMaus <= 10000) {
      setPrice("Free");
    } else {
      const billableMaus = calculatedMaus - 10000;
      const calculatedPrice = (billableMaus / 1000) * 1.99;

      const formattedPrice = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(calculatedPrice);

      setPrice(formattedPrice);
    }
  };

  const handleChange = (event, newValue) => {
    setSlidersValues(newValue);
  };

  useEffect(() => {
    setSlidersValues(5); // Set initial slider value to 5
  }, []);

  return (
    <OuterWrapper>
      <Container>
        <Content>
          <TextWrapper>
            <Title>Calculate Cost</Title>
            <Subtitle>
              Estimate costs based on your usage. For enterprise plans with over
              1,000,000 monthly active users, <a href="/sales">contact us</a> to
              discuss custom pricing options.
            </Subtitle>
          </TextWrapper>
          <SliderContent>
            <SliderWrapper style={{ width: "100%" }}>
              <SliderTitle>
                Monthly Active Users
                <span style={{ marginLeft: "12px" }}>
                  {maus.toLocaleString()}
                </span>
              </SliderTitle>
              <CustomSlider value={sliderValue} onChange={handleChange} />
            </SliderWrapper>
            <SliderWrapper>
              <SliderTitle>Price / month</SliderTitle>
              <SliderPrice>{price}</SliderPrice>
            </SliderWrapper>
          </SliderContent>
        </Content>
      </Container>
    </OuterWrapper>
  );
};

export default CalculateCost;

const Container = styled.div`
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 80px;
padding:150px 100px 80px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 50px;
  }

  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  background: ${lightThemeColors.darkColor};
`;
const OuterWrapper = styled.div`
  background: ${lightThemeColors.darkColor};
  color: ${lightThemeColors.darkColor};
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 100px;
  @media (max-width: 990px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  max-width: 500px;
  @media (max-width: 990px) {
    max-width: 100%;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.lightColorFaded};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  a {
    color: ${lightThemeColors.lightColorFaded};
  }
`;
const SliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const SliderTitle = styled.p`
  color: ${lightThemeColors.lightColor};
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;

  span {
    color: rgba(150, 191, 255, 1);
  }
`;
const SliderPrice = styled.p`
  color: rgba(65, 95, 245, 1);
  font-weight: 700;
  font-size: 30px;
  line-height: 34px;
  min-width: 140px;
`;
const SliderContent = styled.div`
  display: flex;
  gap: 70px;
  width: 100%;
  align-items: center;
`;
